import { PeriodPickerProps } from '@touche-lts/panel-ui/dist/components/shared/period-picker'

export enum ActionHistoryTableSortProps {
    TIME = 'time',
    ENTITY_TITLE = 'entityTitle',
    ACTION_TYPE = 'actionType',
    CHANGES = 'changes',
    USER_NAME = 'userFullname'
}

export enum ActionHistoryTableStatus {
    STORE_CREATE = 'Store Create',
    STORE_UPDATE = 'Store Update',
    STORE_DELETE = 'Store Delete',
    PRODUCT_CREATE = 'Product Create',
    PRODUCT_ADD = 'Add Product',
    PRODUCT_UPDATE = 'Product Update',
    PRODUCT_REMOVE = 'Product Remove',
    ADD_SHIPPING_TO_STORE = 'Add Shipping',
    REMOVE_SHIPPING_FROM_STORE = 'Remove Shipping',
    SHIPPING_UPDATE = 'Shipping Update',
    DEPARTMENT_CREATE = 'Department Create',
    DEPARTMENT_UPDATE = 'Department Update',
    DEPARTMENT_DEACTIVATED = 'Department Deactivated'
}

export interface ActionHistoryTableSearchProps {
    actionType: string;
    changes: any;
    entityTitle: string;
    periodFrom: string;
    periodTo: string;
    orderDate?: PeriodPickerProps['period'];
    userFullname: string;
}
